export default "/images/002bb914661ee1c82bfea2d30592d4cd.png";